<nav class="navbar navbar-background">
  <div class="container-fluid nav-shell">
    <div class="navbar-header">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-mark">
          <img class="logo" src="assets/images/logo.png" alt="Logo" height="25">
        </span>
        <span class="brand-wordmark">CALIPOLI</span>
      </a>

      <button
        class="navbar-toggler"
        type="button"
        (click)="toggleMenu()"
        [attr.aria-expanded]="isMenuOpen"
        aria-label="Toggle navigation"
        aria-controls="navbarMenu"
      >
        <i class="fa-solid fa-bars"></i>
      </button>
    </div>

    <div id="navbarMenu" class="navbar-collapse" [class.show]="isMenuOpen">
      <ul class="navbar-nav nav-primary me-auto">
        @if (isAuthenticated$ | async) {
          <li class="nav-item">
            <a [routerLink] = "['/mypage']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link" data-testId="myPosts" [attr.aria-label]="'menu.myPosts' | translate" [title]="'menu.myPosts' | translate">
              <i class="fa-solid fa-house"></i>
            </a>
          </li>
          <li class="nav-item">
            <button type="button" (click)="goToStudio()" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link nav-link-accent" data-testId="CalipoliStudio">Calipoli Studio</button>
          </li>
          <li class="nav-item">
            <a [routerLink] = "['/contact']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link">{{'menu.contact' | translate}}</a>
          </li>
        }

        @if (!(isAuthenticated$ | async)) {
          <li class="nav-item">
            <a [routerLink] = "['/user/login']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link" data-testId="login">{{'menu.login' | translate}}</a>
          </li>

          <li class="nav-item">
            <a [routerLink] = "['/about']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link">{{'menu.about' | translate}}</a>
          </li>

          <li class="nav-item">
            <a [routerLink] = "['/pricing']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link">{{'menu.pricing' | translate}}</a>
          </li>

          <li class="nav-item">
            <a [routerLink] = "['/user/register']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link nav-link-cta" data-testId="register">{{'menu.register' | translate}}</a>
          </li>
        }
      </ul>

      <ul class="navbar-nav nav-secondary ms-auto">
        @if (isAuthenticated$ | async) {
          <!--
            Timer indicator is intentionally hidden for now.
            Keep this block for quick re-enable in the future.
          <li class="nav-item me-3">
            <span class="nav-link" data-testId="remainingTime"><i class="fa-regular fa-clock me-1"></i>{{remainingTime}} min</span>
          </li>
          -->
          <li class="nav-item">
            <a [routerLink] = "['/shoppingCart']" routerLinkActive="activeClass" [routerLinkActiveOptions]="{exact:true}" class="nav-link"><i class="fa-solid fa-cart-shopping"></i></a>
          </li>
        }
        <li class="nav-item dropdown">
          <button class="nav-link dropdown-toggle" type="button" id="navbarDropdown" (click)="toggleLanguageMenu($event)" [attr.aria-expanded]="isLanguageMenuOpen">
            <i [ngClass]="getLanguageFlag('')" class="flag m-0"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown" [class.show]="isLanguageMenuOpen">
            <li>
              <a class="dropdown-item language-option" [routerLink] = "[]">
                <span class="language-option-main">
                  <i [ngClass]="getLanguageFlag('')" class="fi"></i>
                  <span class="language-label">{{languageDescription}}</span>
                </span>
                <i class="fa fa-check text-success language-check"></i>
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a (click)="useLanguage('en');$event.preventDefault();" class="dropdown-item language-option" [routerLink] = "[]">
                <span class="language-option-main">
                  <i data-testId="fi-us" class="fi-us fi"></i>
                  <span class="language-label">English</span>
                </span>
              </a>
            </li>
            <li>
              <a (click)="useLanguage('pt-BR');$event.preventDefault();" class="dropdown-item language-option" [routerLink] = "[]">
                <span class="language-option-main">
                  <i class="fi-br fi"></i>
                  <span class="language-label">Portugu&ecirc;s (BR)</span>
                </span>
              </a>
            </li>
            <li>
              <a (click)="useLanguage('pt-PT');$event.preventDefault();" class="dropdown-item language-option" [routerLink] = "[]">
                <span class="language-option-main">
                  <i class="fi-pt fi"></i>
                  <span class="language-label">Portugu&ecirc;s (PT)</span>
                </span>
              </a>
            </li>
          </ul>
        </li>

        @if (isAuthenticated$ | async) {
          <li class="nav-item dropdown ms-auto">
            <button class="nav-link dropdown-toggle" type="button" id="userDropdown" (click)="toggleUserMenu($event)" [attr.aria-expanded]="isUserMenuOpen">
              <span class="user-greeting">{{'menu.hello' | translate}}, {{(user$ | async)?.name}}</span>
            </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown" [class.show]="isUserMenuOpen">
                <li>
                  <a class="dropdown-item" [routerLink] = "['/user/profile']" (click)="closeUserMenu()">{{'menu.profile' | translate}}</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink] = "['/user/purchases']" (click)="closeUserMenu()">{{'menu.purchases' | translate}}</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink] = "['/user/billing']" (click)="closeUserMenu()">{{'menu.billing' | translate}}</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink] = "['/user/logout']" (click)="closeUserMenu()">{{'menu.logout' | translate}}</a>
                </li>
              </ul>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
